import React from 'react';
import { CircularProgress, Box } from '@mui/material';

function LoadingAnimation() {
  return (
    <Box 
      display="flex" 
      justifyContent="center" 
      alignItems="center" 
      height="100vh" 
      width="100vw"
      position="fixed"
      top={0}
      left={0}
      bgcolor="rgba(0, 0, 0, 0.5)"
      zIndex={10000}
    >
      <CircularProgress style={{ color: '#ffffff' }} />
    </Box>
  );
}

export default LoadingAnimation;

// Usage example:
// {loading && <LoadingAnimation />}
